import React from 'react';
import moment from 'moment';
// styles
const styles = require('./status-details.scss');
// images
const logo = require('../../images/logo_airportr.svg');


interface IProps {
  data: ICollectionSlot;
  displayMessage: string;
  language: string;
  multiLang: any;
}

interface IState {
  data: ICollectionSlot;
  displayMessage: string;
}

interface ICollectionSlot {
  dateTime: string;
  slot: string;
}


class StatusDetailsComponent extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      data: props.data,
      displayMessage: props.displayMessage
    };
  }

  componentWillReceiveProps(props: IProps) {
    if (props.data !== null) {
      this.setState({ data: props.data });
    }
  }

  public render() {
    const { language, multiLang } = this.props;

    return (
      <div className={styles.card}>
        <div className={styles.cardHeader}>
          {/* copy: pending for placeholder*/}
          {/* copy with replacement */}
          <h3>{multiLang[`${this.state.displayMessage}${language}`]}</h3>
          <img src={logo} />
        </div>
        <div className={styles.cardBody}>
          <div>
            <p className={styles.timeslot}>{this.state.data.slot}</p>
            <p>{moment(this.state.data.dateTime).format('dddd Do MMMM')}</p>
          </div>
          <div className={styles.linkWrapper}>
            <i className={styles.icon}>clock</i>
          </div>
        </div>
      </div>
    );
  }

}

export default StatusDetailsComponent;



// WEBPACK FOOTER //
// ./src/components/status-details/status-details.component.tsx